import { render, staticRenderFns } from "./NatureCharacter.vue?vue&type=template&id=6e4ad9f2&"
import script from "./NatureCharacter.vue?vue&type=script&lang=js&"
export * from "./NatureCharacter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports